import { useState } from "react";
import { Link } from "react-router-dom";
import { Loader2, MailCheck } from "lucide-react";
import AuthPage, { inputClass, labelClass, primaryBtn } from "@/components/account/AuthPage";
import { api, formatApiError } from "@/lib/api";
import { useLang } from "@/lib/i18n";
import { useSeo } from "@/lib/seo";

export default function ForgotPassword() {
  const { t, lang } = useLang();
  useSeo({ title: `${t("auth.forgotTitle")} – Nivå Digital`, description: t("auth.forgotSub"), noindex: true });
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email, lang });
      setDone(true);
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthPage tag={t("nav.account")} title={t("auth.forgotTitle")} sub={t("auth.forgotSub")} testid="forgot-page">
      {done ? (
        <div data-testid="forgot-success" className="flex flex-col items-center py-6 text-center">
          <MailCheck className="h-12 w-12 text-mint" />
          <h2 className="mt-5 font-display text-xl font-bold text-bone">{t("auth.checkInbox")}</h2>
          <p className="mt-3 text-sm leading-relaxed text-fog">{t("auth.forgotSent").replace("{email}", email)}</p>
          <Link data-testid="forgot-to-login" to="/logga-in" className="mt-6 text-sm font-semibold text-mint hover:underline">
            {t("auth.loginLink")}
          </Link>
        </div>
      ) : (
        <form data-testid="forgot-form" onSubmit={submit} className="space-y-5">
          <div>
            <label htmlFor="forgot-email" className={labelClass}>{t("auth.email")}</label>
            <input id="forgot-email" data-testid="forgot-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className={inputClass} autoComplete="email" />
          </div>
          {error && <p data-testid="forgot-error" className="rounded-lg border border-red-500/30 bg-red-500/10 px-3 py-2 text-sm text-red-400">{error}</p>}
          <button data-testid="forgot-submit" type="submit" disabled={loading} className={primaryBtn}>
            {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : t("auth.forgotBtn")}
          </button>
          <p className="text-center text-sm text-fog">
            <Link data-testid="forgot-login-link" to="/logga-in" className="font-semibold text-mint hover:underline">{t("auth.loginLink")}</Link>
          </p>
        </form>
      )}
    </AuthPage>
  );
}
